
import React from 'react';

import Main from './layouts/Main/Main';
import Loading from './layouts/Loading/Loading';
import Error from './layouts/Error/Error';
import BlockedContent from './layouts/BlockedContent/BlockedContent';
import WithTagging from './layouts/WithTagging/WithTagging';
import WithChat from './layouts/WithChat/WithChat';

import NoDisplayedLoading from './components/NoDisplayedLoading/NodisplayedLoading';

import Configuration, * as ConfigurationConstants from './controllers/Configuration';
import Content from './controllers/Content';
import PostMessages from './controllers/PostMessages';
import QueryStrings from './controllers/QueryStrings';
import Restrictions, * as RestrictionsConstants from './controllers/Restrictions';
import SrcTester, * as SrcTesterConstants from './controllers/SrcTester';
import CustomLogger, { Constants as CustomLoggerConstants } from './controllers/CustomLogger';
import Analytics from './controllers/Analytics/Base';

import { add_to_local_storage_counter } from './helpers/utils';

class Iframe extends React.Component {

  constructor( props) {
    super( props);
    this.state = {
      error: null,
      configuration: null,
      configurationState: ConfigurationConstants.States.Loading,
      restrictionsState: RestrictionsConstants.States.Pending,
      blockedOptions: null,
      srcTesterState: SrcTesterConstants.States.Pending,
    };
    this.setSettings = this.setSettings.bind( this);
    this.setHandlers = this.setHandlers.bind( this);
    this.loadAsyncScripts = this.loadAsyncScripts.bind( this);
    this.releaseHandlers = this.releaseHandlers.bind( this);
    this.removeAsyncScripts = this.removeAsyncScripts.bind( this);
    this.verifyRestrictions = this.verifyRestrictions.bind( this);
    this.testSrcs = this.testSrcs.bind( this);
    this.renderConditionalLoading = this.renderConditionalLoading.bind( this);

    this.customLoggerScript = null;
  }

  renderConditionalLoading() {
    return this.state.configuration?.auxiliarData?.displayLoading ? <Loading /> : <NoDisplayedLoading />;    
  }

  render() {
    // console.log( 'Iframe::Iframe::render() - this.state: ', this.state);    // DEVELOP

    const onPlayer = player => {
      const videoElement = document.querySelectorAll( '.PlayerContainer video')[0];   // REVIEW TODO importar PlayerContainer de archivo de constantes aqui y en los layouts
      PostMessages.onPlayer( player);
      Content.onPlayer( player);
      CustomLogger.onPlayer( player, videoElement);   // NOTE esto solo es compatibles con players que usen por debajo la etiqueta video de html5
    };

    if( this.state.error) return <Error {...this.state.error}/>;
    switch( this.state.configurationState) {
      case ConfigurationConstants.States.Loading: return this.renderConditionalLoading();
      case ConfigurationConstants.States.Loaded: 
        switch( this.state.restrictionsState) {
          case RestrictionsConstants.States.Pending:
          case RestrictionsConstants.States.Verifying:
            return this.renderConditionalLoading();
          case RestrictionsConstants.States.Verified:
            switch( this.state.srcTesterState) {
              case SrcTesterConstants.States.Pending:
              case SrcTesterConstants.States.Testing:
                return this.renderConditionalLoading();
              case SrcTesterConstants.States.Tested:
                switch( this.state.configuration.layout) {
                  case ConfigurationConstants.Layouts.Main:
                    return <Main {...this.state.configuration} onPlayer={onPlayer}/>;
                  case ConfigurationConstants.Layouts.WithTagging:
                    return <WithTagging {...this.state.configuration} onPlayer={onPlayer}/>;
                  case ConfigurationConstants.Layouts.WithChat:
                    return <WithChat {...this.state.configuration} onPlayer={onPlayer}/>;
                  default:
                    console.warn( 'Iframe::Iframe::render() - unrecognize layout: ', this.state.configuration.layout);
                    return <div/>;
                }
              default:
                console.warn( 'Iframe::Iframe::render() - unrecognize srcTesterState: ', this.state.srcTesterState);
                return <div />;
            }
          case RestrictionsConstants.States.Blocked:
            return <BlockedContent blockedOptions={this.state.blockedOptions} auxiliarData={this.state.configuration.auxiliarData}/>;
          default:
            console.warn( 'Iframe::Iframe::render() - unrecognize restrictionsState: ', this.state.restrictionsState);
            return <div/>;
        }
      default:
        console.warn( 'Iframe::Iframe::render() - unrecognize configurationState: ', this.state.configurationState);
        return <div/>;
    }
  }

  async testSrcs() {
    try {
      this.setState({ srcTesterState: SrcTesterConstants.States.Tested, configuration: await SrcTester.test( this.state.configuration) });
    } catch( error) {
      console.error( 'Iframe::Iframe::testSrcs() - error testing srcs: ', error);
    }
  }

  async verifyRestrictions() {
    // console.log( 'Iframe::Iframe::verifyRestrictions()');    // DEVELOP
    try {
      await Restrictions.verify( this.state.configuration.playbackRestrictions, ({state: restrictionsState, blockedOptions}, error) => {
        this.setState({ restrictionsState, blockedOptions, error, srcTesterState: SrcTesterConstants.States.Testing });
        this.testSrcs();    // REVIEW React.setState - callback
      });
    } catch( error) {
      console.error( 'Iframe::Iframe::verifyRestrictions() - error verifying restrictions: ', error);
    }
  }

  componentDidUpdate() {
    if( !this.state.error && this.state.configurationState === ConfigurationConstants.States.Loaded) {
      if( this.state.restrictionsState === RestrictionsConstants.States.Pending) {
        this.setState({ restrictionsState: RestrictionsConstants.States.Verifying });
        this.verifyRestrictions();    // REVIEW React.setState - callback
      }
      PostMessages.onConfiguration( this.state.configuration, updatedConfiguration => {
        // console.log( 'Iframe::Iframe::componentDidUpdate - PostMessages.onConfiguration(callback) - updatedConfiguration: ', updatedConfiguration, ', this.state.configuration: ', this.state.configuration);    // DEVELOP
        // TODO full update configuration processing - verify restrictions ?, override with query params ?, ...
        if( updatedConfiguration ) {
          const { platformId, firstUrl, srcType } = updatedConfiguration.auxiliarData;
          CustomLogger.setValues( platformId, firstUrl, srcType);
        }
        this.setState({ configuration: updatedConfiguration });
      });
    }
  }

  async setSettings() {
    // console.log( 'Iframe::Iframe::setSettings()');    // DEVELOP
    try {
      await Configuration.load( this.props.match.params.iframeId, (configuration, error) => {   // REVIEW considerar incluir configurationState como parametro de la funcion de callback (ver verifyRestrictions)
        if( configuration) {
          configuration = QueryStrings.overrideConfiguration( configuration, this.props.location);
          const { platformId, firstUrl, srcType } = configuration.auxiliarData;
          CustomLogger.setValues( platformId, firstUrl, srcType);
          Analytics.onLoad( configuration.analyticsConfiguration);
        }
        this.setState({ configuration, error, configurationState: ConfigurationConstants.States.Loaded });
      });
    } catch( error) {
      console.error( 'Iframe::Iframe::setSettings() - error loading settings: ', error);
    }
  }

  async setHandlers() {
    // console.log( 'Iframe::Iframe::setHandlers()');    // DEVELOP
    try {
      await PostMessages.listen();
    } catch( error) {
      console.error( 'Iframe::Iframe::setHandlers() - error setting handlers: ', error);
    }
  }

  loadAsyncScripts() {
    this.customLoggerScript = document.createElement( 'script');
    this.customLoggerScript.src = CustomLoggerConstants.src;
    this.customLoggerScript.async = true;
    this.customLoggerScript.onload = CustomLogger.onLoad;
    document.head.append( this.customLoggerScript );
  }

  componentDidMount() {
    // console.log( 'Iframe::Iframe::componentDidMount()');    // DEVELOP
    this.setSettings();
    this.setHandlers();
    this.loadAsyncScripts();
    // window.addEventListener('beforeunload',this.clearSettings);
    window.addEventListener('beforeunload', event => {
      // event.preventDefault();
    //   add_to_local_storage_counter('Iframe::componentDidMount-beforeunload');
      this.clearSettings();
    //   return event.returnValue = 'beforeunload';
    });
  }

  async clearSettings() {
    try {
      add_to_local_storage_counter('Iframe::clearSettings');
      if( this.state.configuration) {
        add_to_local_storage_counter('Iframe::clearSettings-if');
        Analytics.onUnload( this.state.configuration.analyticsConfiguration);
      }
    } catch( error) {
      console.error( 'Iframe::Iframe::clearSettings() - error clearing settings: ', error);
    }
  }

  async releaseHandlers() {
    // console.log( 'Iframe::Iframe::releaseHandlers()');    // DEVELOP
    try {
      await PostMessages.stop();
    } catch( error) {
      console.error( 'Iframe::Iframe::releaseHandlers() - error releasing handlers: ', error);
    }
  }

  removeAsyncScripts() {
    if( this.customLoggerScript) this.customLoggerScript.remove();
  }

  componentWillUnmount() {
    // console.log( 'Iframe::Iframe::componentWillUnmount()');   // DEVELOP
    add_to_local_storage_counter('Iframe::componentWillUnmount');
    this.clearSettings();
    add_to_local_storage_counter('Iframe::componentWillUnmount-clearSettings');
    this.releaseHandlers();
    this.removeAsyncScripts();
    add_to_local_storage_counter('Iframe::componentWillUnmount-finished');
  }

}

export default Iframe;
